import React, {Component} from 'react';
import PropTypes from 'prop-types';

import { mapElements } from '../../assets/assets';
import scrollIntoView from "scroll-into-view";

let flag = 0;
export default class MapPolicy extends Component {
  static propTypes = {
    title: PropTypes.string,
    top: PropTypes.number,
    left: PropTypes.number,
    feedbackCount: PropTypes.number,
    number: PropTypes.number,
    suffix: PropTypes.string,
  }
  constructor(props) {
    super(props);
    this.state = {};
  }

  isTouchDevice () {
    let isTouch = true;
    window.addEventListener('mousemove', function mouseMoveDetector() {
      isTouch = false;
      window.removeEventListener('mousemove', mouseMoveDetector);
    });

    return isTouch
  }

  goToClick = (e, target) => {
    e.preventDefault();
    if (!flag) {
      if (this.props.unHighlight === false) {
        target = '/'
      }
      sessionStorage.setItem('toMin', 'map');
      this.props.history.push(target);
    }

    flag = 0;
  };

  goToMouse = (e, target) => {
    e.preventDefault();

    e.target.addEventListener('mousemove', function(){
      flag = 1;
    });
    e.target.addEventListener('mouseup', () => {
      if (!flag) {
        if (this.props.unHighlight === false) {
          target = '/'
        }
        //🤮🤮🤮
        sessionStorage.setItem('toMin', 'map');
        this.props.history.push(target);
        if( !(this.props.unHighlight === false) ) {
          if(this.props.gameState && this.props.gameState.difficulty === "BASIC"){
            target = target.split('/').find(i => i.length === 2);
          }
          if(window.innerWidth < 1024) return;
          scrollIntoView(
            document.getElementById("scrollto-beleidskeuzes").closest(".economy-list"),
            {
              topOffset: 200,
            }
          );
        }
      }
      flag = 0;
    });

    flag = 0;
  };

  render() {
    return (
      <a className={this.props.unHighlight ? 'MapElement MapElement--economy beleidskeuze-map hide' : this.props.unHighlight === false ? 'MapElement MapElement--economy beleidskeuze-map show' : 'MapElement MapElement--economy beleidskeuze-map'}
        onClick={(e) => this.goToClick(e, this.props.target)} onMouseDown={(e) => this.goToMouse(e, this.props.target)}
        style={{
          top: this.props.top + "%",
          left: this.props.left + "%",
        }}>
        <div className="content">
          <img src={ mapElements['map_Beleidskeuzes'] } alt={this.props.title}/>
          <div className="overlay">
            <div className="content">
              {this.props.feedbackCount > 0 ?
                <div className={`notification-count ${(this.props.step === 3 ? ' red' : '')}`}>
                  <span>
                    <p>{this.props.feedbackCount}</p>
                  </span>
                </div> :
              ''}
              <div text={this.props.number} className="score">
                {this.props.number}
                <span text={this.props.suffix}>{this.props.suffix}</span>
              </div>
            </div>
          </div>
        </div>
        <div className={'name'} text={this.props.title}>{this.props.title}</div>
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/MapPolicy.js